import { MentiError } from '@mentimeter/error-utils/error';
import type { FeatureOwner } from '@mentimeter/error-utils/feature-owners';
import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';

export function usePageError({
  error,
  message,
  feature,
}: {
  error: Error;
  message: string;
  feature: FeatureOwner;
}) {
  useEffect(() => {
    if (
      error instanceof MentiError ||
      error?.constructor?.name === 'MentiError' ||
      (error as MentiError | undefined)?.isMentiError === true
    ) {
      /**
       * Currently, MentiError can be imported from `@mentimeter/error-utils/error`
       * or `@mentimeter/errors/sentry`, which could get treated as different classes.
       */
      captureException(error);
    } else {
      captureException(
        new MentiError(message, {
          cause: error,
          feature,
        }),
      );
    }
  }, [error, message, feature]);
}
